module.exports = __webpack_public_path__ + "static/img/animation5.8e3a96b.png";